// extracted by mini-css-extract-plugin
module.exports = {"reminder":"Reminder_pc_reminder__ApUtk","svg":"Reminder_pc_svg__f5fFF","link":"Reminder_pc_link__oSnn5"};